<template>
    <div id="app">
        <v-app id="inspire">  
            <v-container grid-list-md text-xs-center>
                <v-layout row wrap>
                    <v-flex xs12 sm12 md12 lg12>
                        <v-card>
                            <v-card-title><h3>For Approval</h3> <v-spacer></v-spacer>
                                <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
                            </v-card-title>

                            <div class="text-xs-center">
                                <v-flex xs12>
                                    <v-data-table :search="search" :headers="headers" :items="lists" class="elevation-1">
                                        <template v-slot:items="props">
                                            <td class="text-xs-left">{{ props.item.formatedDate }}</td>
                                            <td class="text-xs-left">{{ props.item.appointmentTime }}</td>
                                            <td class="text-xs-left"> <div v-for="(service,index) in props.item.initialService" :key="index">{{service.displayName }} </div>
                                            <div v-for="(service,index2) in props.item.otherService" :key="index2">{{service.service }} </div>
                                            </td>
                                            <td class="text-xs-left">{{ props.item.userDetails.fullName }}</td>
                                            <td class="justify-center">
                                                <v-btn small outline color="primary" @click="requestForChange(props.item)">view</v-btn>
                                            </td>
                                        </template> 

                                        <template v-slot:no-data>
                                            <v-alert :value="true" color="grey">
                                                No Data Available
                                            </v-alert>
                                        </template>

                                        <template v-slot:no-results>
                                            <v-alert :value="true" color="red accent-4" icon="warning">
                                                Your search for "{{ search }}" found no results.
                                            </v-alert>
                                        </template>
                                    </v-data-table>
                                </v-flex>
                            </div>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>

            <v-dialog v-model="editDialog" persistent max-width="80%">
                <v-card v-if="forChange.userDetails">
                    <v-container fluid class="pa-0" grid-list-md>
                        <v-parallax dark class="blue-grey darken-3" height="70">
                            <v-layout>
                                <v-card-title class="title font-weight-black"> 
                                    {{branch.split('_')[1].trim()}} 
                                </v-card-title>
                                <v-spacer></v-spacer>
                                <v-btn dark  icon @click="editDialog = false">
                                    <v-icon>close</v-icon>
                                </v-btn> 
                            </v-layout>
                        </v-parallax> 

                        <v-layout wrap> 
                            <v-flex xs4>
                                <v-card-title class="subtitle-1 font-weight-bold pb-0"> 
                                    Owner: {{forChange.userDetails.fullName}}
                                </v-card-title>

                                <v-card-title v-if="forChange.userDetails.address" class="subtitle-1 font-weight-black pb-0 pt-0"> 
                                    Address: {{forChange.userDetails.address.brgy}} {{forChange.userDetails.address.city}} {{forChange.userDetails.address.state}}
                                </v-card-title>

                                <v-card-title class="subtitle-1 font-weight-black pb-0 pt-0"> 
                                    Mobile Number: {{forChange.userDetails.mobileNumber}}
                                </v-card-title>

                                <v-card-title class="subtitle-1 font-weight-black pt-0 pb-0"> 
                                    Email: {{forChange.userDetails.email}}
                                </v-card-title>
                            </v-flex>

                            <v-flex xs4>
                                <v-card-title class="subtitle-1 font-weight-black pb-0"> 
                                    Dealer: {{forChange.motorcycleDetails.dealer}}<br>
                                    Brand: {{forChange.motorcycleDetails.make}}<br>
                                    Model: {{forChange.motorcycleDetails.model}}<br>
                                    Classification: {{forChange.motorcycleDetails.classification}}<br>
                                </v-card-title>

                                <v-card-title class="subtitle-1 font-weight-black pt-0 pb-0"> 
                                    Mileage: {{forChange.odometer}} km
                                </v-card-title>
                            </v-flex>

                            <v-flex xs4>
                                <v-card-title class="subtitle-1 font-weight-black pt-2 pb-0"> 
                                    Date: {{forChange.formatedDate}}
                                </v-card-title>

                                <v-card-title class="subtitle-1 font-weight-black pt-0 pb-0"> 
                                    Schedule Time: {{forChange.appointmentTime}}
                                </v-card-title>

                                <v-card-actions class="pt-0 pb-0">
                                    <v-checkbox label="Send Notification" v-model="notificationBox"></v-checkbox>
                                </v-card-actions>
                            </v-flex>
                        </v-layout>
                        <v-divider></v-divider>

                        <v-layout>
                            <v-flex xs7 justify-center class="pt-0">
                                <v-container grid-list-sm fluid>
                                    <v-layout row wrap class="justify center">
                                        <v-flex xs7 v-for="(service,index) in serviceMenu" :key="index" class="pt-0">
                                            <v-card-actions class="pt-0 pb-0">
                                                <v-checkbox v-model="selected.service" :label="service.displayName" :value="service"></v-checkbox>
                                            </v-card-actions>
                                            <v-card-title class="caption font-weight-regular pt-0 pb-0">{{service.displayDescription}}
                                            </v-card-title>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-flex>

                            <v-flex xs5>
                                <v-container>
                                    <v-layout v-for="(list,index) in otherServices" :key="index">
                                        <v-flex xs8>
                                            <v-text-field class="pl-4" v-model="otherServices[index].service" label="Others" placeholder="Please Specify" required readonly>
                                            </v-text-field>
                                        </v-flex>

                                        <v-flex xs4>
                                            <v-select v-model="otherServices[index].time" :items="otherTimeRate" label="Time" required
                                            > </v-select>
                                        </v-flex>
                                    </v-layout>

                                    <v-card-actions class="justify-end">
                                        <v-btn color="red accent-4" @click="rejectDialog=true" dark>Unavailable</v-btn>
                                        <v-btn color="green darken-4" @click="approveDialog=true" dark>Approve</v-btn>
                                    </v-card-actions>
                                </v-container>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card>
            </v-dialog>

            <v-dialog v-model="rejectDialog" max-width="500px" persistent>
                <v-card>
                    <v-parallax dark class="blue-grey darken-3" height="80">
                        <v-spacer></v-spacer>
                        <v-container>
                            <v-layout><br>
                            <h4 class="title font-weight-medium">Confirm Unavailability of Slot </h4>
                            </v-layout>
                        </v-container>
                    </v-parallax>

                    <v-container grid-list>
                        <v-card-text class="subheading font-weight-regular">
                        You are about to cancel the requested service appointment by customer.
                        </v-card-text>

                        <v-card-text class="subheading font-weight-regular">
                        Do you want to proceed?
                        </v-card-text>

                        <v-card-actions class="justify-center">
                            <v-btn dark color="red accent-4" @click="rejectDialog=false">NO</v-btn>
                            <v-btn dark color="blue darken-4" @click="rejectValidation(forChange,'Rejected')">YES</v-btn>
                        </v-card-actions>
                    </v-container>
                </v-card>
            </v-dialog>

            <v-dialog v-model="approveDialog" max-width="500px" persistent>
                <v-card>
                    <v-parallax dark class="blue-grey darken-3" height="80">
                        <v-spacer></v-spacer>
                        <v-container>
                            <v-layout><br>
                            <h4 class="title font-weight-medium">Are you sure you want to approve this appointment in the list? </h4>
                            </v-layout>
                        </v-container>
                    </v-parallax>

                    <v-container grid-list>
                        <v-card-text class="subheading font-weight-regular">
                        You are about to queue the request schedule appointment in the list.
                        </v-card-text>
                        <v-card-text class="subheading font-weight-regular">
                        Do you want to proceed?
                        </v-card-text>

                        <v-card-text class="subheading font-weight-regular pt-0 pb-0 pl-3 pr-3">Remarks</v-card-text>
                        <v-textarea class="subheading font-weight-regular pt-0 pb-0 pl-3 pr-3" outline solo v-model="remarks"></v-textarea>

                        <v-card-actions class="justify-center">
                            <v-btn dark color="red accent-4" @click="approveDialog=false">NO</v-btn>
                            <v-btn dark color="blue darken-4" @click="approveValidation(forChange,'Waiting')">YES</v-btn>
                        </v-card-actions>
                    </v-container>
                </v-card>
            </v-dialog>
            <Snackbar v-model="snackbar.show" :type="snackbar.type" :message="snackbar.message" />
            <Progress v-model="progress.show" :message="progress.message" />
        </v-app>
    </div>
</template>

<script>
import _ from "lodash"
import firebase from "firebase"
import {db} from "../main"
import { mapGetters, mapState } from "vuex"
import moment from 'moment'
import Progress from '../extras/Progress.vue'
import Snackbar from '../extras/Snackbar.vue'
export default {
    components: {
        Snackbar,
        Progress
    },
    data: () => ({
        date: moment().utcOffset('+0800').toISOString().substr(0, 10),
        headers: [
            { text: 'Date', align: 'left', sortable: true, value: 'transactionId'},
            { text: 'Time', align: 'left', value: 'customerType',  sortable: false  },
            { text: 'Services', align: 'left', value: 'appointmentDate',  sortable: true  },
            { text: 'Customer Name', align: 'left', value: 'appointmentDate',  sortable: true  },
            { text: 'Action', align: 'center'}
        ],
        search: "",
        lists: [],
        events: [],
        editDialog: false,
        branch: "",
        forChange: {},
        serviceMenu: [],
        otherServices: [{
            service: "",
            price: 0,
            time: 0,
        }],
        selected: {
            service: []
        },
        otherTimeRate: [],
        timeHolder: [],
        estimateTime: 0,
        status: "",
        reservedTime: [],
        rejectDialog: false,
        timeValidation: [],
        timeValidation2: [],
        times: [],
        laps: [],
        remarks: "",
        approveDialog: false,
        reasons: [],
        bufferTime: 0,
        mcDetails: {},
        mechanic: "",
        branchId: "",
        notificationBox: true,
        snackbar: {
            responseMessage: "",
            show: false,
            type: "success"
        },
        progress: {
            message: "",
            show: false,
        },
    }),

    methods : {
        showSnackbarMessage(message, success = true) {
            this.snackbar.type = success ? "success" : "error"
            this.snackbar.message = message
            this.snackbar.show = true
        },
        showProgress(message) {
            this.progress.message = message
            this.progress.show = true
        },
        stopProgress() {
            this.progress.show = false
        },
        async fetchReasons(){
            let self = this
            self.reasons = []

            await db.collection("Settings"+self.$stage).doc("Rejection")
            .collection("Items").get().then(function(querySnapshot) {
                querySnapshot.forEach(function(doc){
                    self.reasons.push(doc.data().reason)
                })
            }).catch(function(error){
                console.log(error)
                self.showSnackbarMessage("Reason for rejection should be set", false)
            })
        },
        async fetchBufferTime() {
            let self = this
            await db.collection("Settings"+self.$stage).doc("BufferTime")
            .collection("Items").get().then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                    if (!doc.exists) {
                        self.bufferTime = 0
                        self.showSnackbarMessage("Buffer time should be set", false)
                    } else {
                        self.bufferTime = doc.data().time
                    }
                })
            }).catch(function(error) {
                console.log(error)
                self.showSnackbarMessage("Buffer time should be set", false)
            })
        },
        async fetchFlatRate() {
            let self = this    
            self.otherTimeRate = []
            let count = 0

            await db.collection("Settings"+self.$stage).doc("FlatRate")
            .collection("Items").get().then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                    count ++
                    if (!doc.exists) {
                        self.showSnackbarMessage("Flat Rate should be set", false)
                    } else {
                        self.otherTimeRate.push(doc.data().time)
                    }

                    if (count === querySnapshot.docs.length) {
                        self.otherTimeRate.sort(function(a, b){return a-b})
                    }
                })
            }).catch(function(error) {
                console.log(error)
                self.showSnackbarMessage("Flat Rate should be set", false)
            })
        },
        chargeEstimate() {
            let self = this
            self.timeHolder = []
            self.selected.service.forEach(function (result) {
                self.timeHolder.push(Number(result.time))
            })
            self.otherServices.forEach(function (result) {
                self.timeHolder.push(Number(result.time))
            })
            self.estimateTime =  (self.timeHolder.reduce(function(a, b) { return a + b }, 0))
        },
        async getRole() {
            let self = this
            let process = 0
            self.showProgress("Loading Data...")
            await firebase.auth().onAuthStateChanged(async function(user) {
                await db.collection("Users"+self.$stage).doc(user.uid)
                .onSnapshot(async function(doc) {
                    self.branch = doc.data().assign
                    self.branchId = doc.data().assignId
                    process++
                    if(process > 0) {
                        await self.fetchTransactions()
                    }
                })
            })
        },
        async fetchTransactions() {
            let self = this
            self.showProgress("Loading Data...")
            await db.collection("ServiceBooking"+self.$stage)
            .where("branchId","==", self.branchId)
            .where("status","==","ForApproval")
            .onSnapshot(function(querySnapshot) {
               self.lists = []
                querySnapshot.forEach(function(doc) {
                    self.lists.push(doc.data())
                })
            })
            console.log(self.$stage)
            self.stopProgress()
        },
        async fetchServiceMenuPerClass(){
            let self = this
            let list = []
            let count = 0
            self.serviceMenu = []

            await db.collection("ServiceMenu"+`${self.$stage}`).get().then(function(querySnapshot){
                querySnapshot.forEach(function(doc){
                    if (doc.data().status === "active"){
                        list.push(doc.data())
                    }
                })
            }).then(function(){
                list.forEach(function(result){
                    result.classifications.forEach(function(data){
                        if (data.class === self.mcDetails.classification) {
                            self.serviceMenu.push({
                                jobCode: "",
                                id: result.id,
                                displayName: result.serviceName,
                                displayDescription: result.description,
                                time: data.time,
                                classification: data.class
                            })
                            count ++
                        }
                    })
                })

                if (count === list.length) {
                    self.serviceMenu.sort()
                    self.dialog=false
                    self.editDialog = true
                }
            }).catch(function(error) {
                console.log(error)
                self.stopProgress()
                self.showSnackbarMessage("Error fetching service menu", false)
            })
        },
        async requestForChange(forChange){
            let self = this
            self.editDialog = true  
            self.forChange = forChange
            self.fetchMechanics()
            self.selected.service = self.forChange.initialService
            self.otherServices = self.forChange.otherService
            self.mcDetails = self.forChange.motorcycleDetails
            if (self.mcDetails.classification != "" ) {
                await self.fetchServiceMenuPerClass()
            }
        },
        async rejectValidation(data, status) {
            let self = this
            self.editDialog=false
            self.rejectDialog=false
            await self.updateTransaction(data, status)
        },
        async approveValidation(data,status) {
            let self = this
            if (self.reservedTime.includes(data.appointmentTime)) {
                self.showSnackbarMessage("Time is already taken!", false)
            } else {
                self.editDialog=false
                self.approveDialog=false
                await self.updateTransaction(data, status)
            }
        },
        async updateTransaction(data,status) {
            let self = this
            let removedFromDb = []
            let index = []
            self.timeValidation = []
            
            self.timeValidation = {
                appointmentTime: data.appointmentTime,
                blockTime: self.estimateTime / self.bufferTime
            }
            index = self.times.indexOf(self.timeValidation.appointmentTime)
            removedFromDb = self.times.splice(index, self.timeValidation.blockTime)

            await db.collection("ServiceBooking"+self.$stage).doc(data.transactionId)
            .update({
                otherService: self.otherServices,
                status: status,
                remarks: self.remarks,
                estimateTime: self.estimateTime,
                timeHold: removedFromDb,
                dateApproval: moment().format('MMMM Do YYYY, h:mm:ss a')
            }).then(async function() {
                if (self.notificationBox) {
                    await self.notifications(data,status)
                    self.showSnackbarMessage("Updated Successfully", true)
                    self.notificationBox = true
                } else {
                    self.remarks = ""
                    self.showSnackbarMessage("Updated Successfully", true)
                    self.notificationBox = true
                }
            })
        },
        async fetchTimes() {
            let self = this
            await db.collection("ServiceBooking"+self.$stage)
            .where("branchId","==",self.branchId)
            .where("appointmentDate","==",self.forChange.appointmentDate)
            .where("mechanic","==",self.mechanic)
            .where("status","==","Waiting")
            .get().then(function(querySnapshot) {
                querySnapshot.forEach(function(res) {
                    self.reservedTime.push(res.data().appointmentTime)
                })
            })
        },
        async fetchMechanics(details){
            let self = this
            let availableTime = []
            let removedFromDb = []
            let blockTime = 0
            let appointmentTime = ""
            let index = []
            let branchCode = self.branch.split('_')[0].trim()
            self.removed = []
            self.timeValidation = []

            await db.collection("Mechanics"+self.$stage)
            .where("name","==",self.forChange.mechanic)
            .where("branchId","==",self.branchId)
            .get().then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                    self.times = doc.data().time
                    if (doc.data().tag === true) {
                        self.mechanic = doc.data().name
                    }
                })
            }).then(async function() {
                await db.collection("ServiceBooking"+self.$stage)
                .where("mechanic","==",self.forChange.mechanic)
                .where("appointmentDate","==",self.forChange.appointmentDate)
                .where("status","==","Waiting")
                .get().then(function(querySnapshot) {
                    if (querySnapshot.docs.length > 0) {
                        querySnapshot.forEach(function(doc) { 
                            self.timeValidation.push({
                                appointmentTime: doc.data().appointmentTime,
                                blockTime: doc.data().estimateTime / self.bufferTime
                            })
                        })

                        self.timeValidation.forEach(function(val) {
                            index = self.times.indexOf(val.appointmentTime)
                            removedFromDb = self.times.splice(index, val.blockTime)
                        })
                    }
                })
            }).then(async function() {
                await self.fetchTimes()
            })
        },
        notifications(details,status){
            let self = this
            let branch = self.branch.split('_')[1].trim()
            let source = ""

            self.$axios.defaults.headers.common['Authorization'] = self.$smsAuthorization
            self.$axios.defaults.headers.common['Content-Type'] = self.$contentType
        
            let footer = "Note: Services and estimated labor costs are subject to change upon actual diagnosis of your motorcycle's needs by the branch service mechanic.".italics()
            
            let message = "Dear " + details.userDetails.firstName + ",\n\nThank you for booking a service appointment with us! This is to confirm that your unit is scheduled for service on " + details.formatedDate + " at "+ branch+ " with control number "+ details.transactionId +". \n\n" + "Click here to see full details of your appointment".link(self.$clientUrl + "/transactions") + "\n\n" + "Please arrive at least 15 minutes before the time to avoid forfeiture of your slot. Thank you." + "\n\n" + footer

            let emailMessage = message.replace(/(\r\n|\n|\r)/gm, "<br>")

            let smsmessage = "Dear " + details.userDetails.firstName + ",\n\nThank you for booking a service appointment with us! This is to confirm that your unit is scheduled for service on " + details.formatedDate + " at "+ branch+ " with control number "+ details.transactionId +". \n\n" + "Click here to see full details of your appointment: " + self.$clientUrl + "/transactions" + "\n\n" + "Please arrive at least 15 minutes before the time to avoid forfeiture of your slot. Thank you." + "\n\n" + "Note: Services and estimated labor costs are subject to change upon actual diagnosis of your motorcycle's needs by the branch service mechanic."

            if (self.branch.includes("Transcycle")) {
                source = "Transcycle"
            } else if (self.branch.includes("Powercycle")) {
                source = "Powercycle" 
            }

            if (status == "Waiting") {
                let body = {
                    "source": source,
                    "destination": `63${details.userDetails.mobileNumber}`,
                    "text": smsmessage,
                }
                self.$axios.post(self.$smsUrl, body)
            } else {
                self.rejectDialog = false
                let rejectMsg = "Dear " + details.userDetails.firstName + ",\n\nThank you for booking a service appointment with us! We are sorry to inform you that your scheduled for service on "+ details.formatedDate + " at "+ details.branch + " with Control #: " + details.transactionId + " is unavailable." + "\n\nYou can always ask for another schedule at "+ `${self.$clientUrl}/transactions`+" or feel free to visit any of our branches."

                let body = {
                    "source": source,
                    "destination": `63${details.userDetails.mobileNumber}`,
                    "text": rejectMsg,
                }
                self.$axios.post(self.$smsUrl, body).then(function(){
                    self.remarks = ""
                })
            }

            if (status == "Waiting") {
                let load = {
                    "receiver" : details.userDetails.email,
                    "subject" : "Your appointment has been confirmed",
                    "html" : emailMessage
                }
                self.$axios.post(self.$mailerUrl, load)
            } else {
                self.rejectDialog = false
                let rejectMsg = "Dear " + details.userDetails.firstName + ",\n\nThank you for booking a service appointment with us! We are sorry to inform you that your scheduled for service on "+ details.formatedDate + " at "+ details.branch + " with Control #: " + details.transactionId + " is unavailable." + "\n\nYou can always ask for another schedule at "+ `${self.$clientUrl}/transactions` +" or feel free to visit any of our branches."
                let emailRejectMsg = rejectMsg.replace(/(\r\n|\n|\r)/gm, "<br>")

                let load = {
                    "receiver" : details.userDetails.email,
                    "subject" : "Update on your motorcycle service schedule",
                    "html" : emailRejectMsg
                }
                self.$axios.post(self.$mailerUrl, load).then(function(){
                    self.remarks = ""
                })
            }
        }
    },

    async mounted() {
        await this.fetchFlatRate()
        await this.fetchBufferTime()
        await this.fetchReasons()
        await this.getRole()
    },

    computed: {
        ...mapGetters(["user"]),
        ...mapState(["Auth"]),
    },

    watch: {
        otherServices: {
           handler: function(newValue) {
                this.chargeEstimate()
           },
           deep: true
        },
    },
}
</script>
